import React from 'react';

export default function DiscussionTopicsEmptyState() {
  return (
    <div className="d-flex flex-column w-100">
      <div className="onboarding-workspaces-preview-content-item-empty" />
      <div className="onboarding-workspaces-preview-content-item-empty" />
      <div className="onboarding-workspaces-preview-content-item-empty" />
      <div className="onboarding-workspaces-preview-content-item-empty" />
    </div>
  );
}
